export const FullScreenIcon: React.FC = props => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.3594 16.3438H14.1562C14.7364 16.3438 15.2928 16.1133 15.703 15.703C16.1133 15.2928 16.3438 14.7364 16.3438 14.1562V12.3594M16.3438 5.64062V3.84375C16.3438 3.26359 16.1133 2.70719 15.703 2.29695C15.2928 1.88672 14.7364 1.65625 14.1562 1.65625H12.3594M5.64062 16.3438H3.84375C3.26359 16.3438 2.70719 16.1133 2.29695 15.703C1.88672 15.2928 1.65625 14.7364 1.65625 14.1562V12.3594M1.65625 5.64062V3.84375C1.65625 3.26359 1.88672 2.70719 2.29695 2.29695C2.70719 1.88672 3.26359 1.65625 3.84375 1.65625H5.64062"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
